export default __webpack_public_path__ + "static/media/GR3 3B-1EC.5383dcff.jpg";